import styles from "./styles.scss";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { StatusCodes } from "http-status-codes";
import { NoPreview } from "@/assets/illustrations";
import { Button, ButtonSize, ButtonVariant } from "@/components/button";
import { EmptyDataScreen } from "@/components/empty-data-screen";
import { getErrorConfig } from "./configs";
import { getButtonCallback, getErrorStatusCode } from "./utils";
import { ErrorScreenProps } from "./types";

export const ErrorScreen: FC<ErrorScreenProps> = ({
  className,
  buttonClassName,
  iconClassName,
  titleClassName,
  subtitleClassName,
  error,
  isHorizontal,
  icon,
  title,
  subtitle,
  buttonText,
  isIconHidden,
  isTitleHidden,
  isSubtitleHidden,
  onButtonClick,
}) => {
  const navigate = useNavigate();

  const statusCode = getErrorStatusCode(error);
  const handleButtonClick = getButtonCallback(statusCode, navigate);

  if (statusCode === StatusCodes.NOT_FOUND) {
    return <EmptyDataScreen icon={<NoPreview />} />;
  }

  const {
    icon: configIcon,
    title: configTitle,
    subtitle: configSubtitle,
    buttonText: configButtonText,
  } = getErrorConfig(statusCode);

  const errorIcon = icon || configIcon;
  const errorTitle = title || configTitle;
  const errorSubtitle = subtitle || configSubtitle;
  const errorButtonText = buttonText || configButtonText;

  return (
    <div
      className={clsx(
        styles.wrapper,
        isHorizontal && styles.horizontal,
        className,
      )}
    >
      {!isIconHidden && (
        <div className={clsx(styles.icon, iconClassName)}>{errorIcon}</div>
      )}

      <div
        className={clsx(
          styles.contentWrapper,
          isHorizontal && styles.horizontal,
          isIconHidden && styles.noMargin,
        )}
      >
        {!isTitleHidden && (
          <div
            className={clsx(
              styles.title,
              isHorizontal && styles.horizontal,
              isIconHidden && styles.noMargin,
              titleClassName,
            )}
          >
            {errorTitle}
          </div>
        )}

        {!isSubtitleHidden && (
          <div
            className={clsx(
              styles.subtitle,
              isHorizontal && styles.horizontal,
              isIconHidden && isTitleHidden && styles.noMargin,
              subtitleClassName,
            )}
          >
            {errorSubtitle}
          </div>
        )}

        {errorButtonText && (
          <Button
            className={clsx(
              styles.errorScreenButton,
              styles.button,
              isHorizontal && styles.horizontal,
              isIconHidden &&
                isTitleHidden &&
                isSubtitleHidden &&
                styles.noMargin,
              buttonClassName,
            )}
            onClick={onButtonClick || handleButtonClick}
            variant={ButtonVariant.Primary}
            size={ButtonSize.Small}
          >
            {errorButtonText}
          </Button>
        )}
      </div>
    </div>
  );
};
